<section class="container-fluid">
  <div class="form-register mb-1">
    <form [formGroup]="formAdvanceInvoiceConcept">
      <div class="row">
        <div class="col-lg-2 col-md-3 col-sm-6 col-12">
          <app-custom-select formControlName="conceptInvoicingId" [labelText]="'Concepto Fra.'"
            [list]="listConceptInvoicing"></app-custom-select>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="differenceValue"
            [labelText]="'Diferencia'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-3 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="differenceValueFinal" [labelText]="'Diferencia Final'"
            [required]="true"></app-custom-input-decimal>
        </div>
        <div class="col-lg-2 col-md-8 col-sm-12 col-12 d-flex align-items-end gap-2 mt-2">
          <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disableButtonSave" (onClick)="send()">
          </app-custom-button>
          <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'" (onClick)="cancel()">
          </app-custom-button>
        </div>
      </div>
    </form>
  </div>
</section>